export interface DelayCategory {
	DelayCategoryId: null | number;
	DelayCategoryName: string;
	DelayCategoryColor: string;
	Description: string | null;
	DelayAreaAssetId: null | number;
	IsActive: boolean;
}

export const DELAY_CATEGORY_INITIAL_VALUES: DelayCategory = {
	DelayCategoryId: null,
	DelayAreaAssetId: null,
	DelayCategoryName: "",
	DelayCategoryColor: "",
	Description: "",
	IsActive: true,
};
